import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock} from './mock'

export const getHomepage = createAsyncThunk(
  'getHomepage',
  async (_, store: any) => {
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/ramadan_2026_agg_config',
      {},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState: {
  homepage?: {
    activity_status?: number
    is_day_first?: boolean
    activities?: {
      id: number
      title: string
      icon: string
      start_time: string
      end_time: string
      link: string
      status: number
      unread: boolean
      rewards: {
        name?: string
        icon?: string
        has_show_effect: boolean
        id: number
      }[]
    }[]
  }
  videoPlaying?: boolean | null
} = {
  homepage: {},
  videoPlaying: null,
}

export const RamadanHomepage2026Slice = createSlice({
  name: 'RamadanHomepage2026',
  initialState,
  reducers: {
    setVideoPlaying: (state, action) => {
      Object.assign(state, {
        videoPlaying: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      Object.assign(state?.homepage, action.payload)
    })
  },
})

export default RamadanHomepage2026Slice.reducer
export const RamadanHomepage2026Actions = RamadanHomepage2026Slice.actions
